jQuery(document).ready(function ($) {
    /**
   * selector de idioma, hace un redirect al seleccionar un idioma
   */
    $('.selector-idioma').on('change', function () {
        const url = $('.selector-idioma:checked').val()
        window.location = url
    })

    /**
   * agrega la clase active al paginador seleccionado
   */
    $('.page-item .current').each(function () {
        $(this).closest('.page-item').addClass('active')
    })

    /**
   * abre en una nueva ventana los link se compartir en redes sociales
   */
    $('.link-share').on('click', function (e) {
        e.preventDefault()
        const strTitle = 'Social Share'
        const strParam = 'width=' + 500 + ',height=' + 400 + ',resizable=' + 'no'
        window.open($(this).attr('href'), strTitle, strParam).focus()
    })

    /**
   * funcion para copiar al porta papelera la url de la noticias actual
   */
    $('.copy-to-clipboard').on('click', function (e) {
        e.preventDefault()
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) { return navigator.clipboard.writeText($(this).attr('href')) }
        return Promise.reject('The Clipboard API is not available.')
    })

    /**
   * funcion para hacer reset de los input del formulario
   */
    $('.search-field-v2__clean').on('click', function (e) {
        e.preventDefault()
        $('input:text').val('')
    })

    /**
   * Limita la cantidad de caracteres del textarea
   */
    $('.textarea-limit').on('keypress', function (e) {
        const maxLength = 1000
        if ($(this).val().length > maxLength) {
            $(this).val($(this).val().substr(0, maxLength))
        }
    })

    /**
   * Limita un input para solo aceptar numeros
   */
    /* jQuery('.input-number').bind('keyup paste', function(){
        this.value = this.value.replace(/[^0-9]/g, '');
    }); */
    jQuery('.input-number').on('keyup keydown change', function () {
        this.value = this.value.replace(/[^0-9]/g, '')
    })

    /**
   * Limita un input para solo aceptar letras
   */
    jQuery('.input-letters').on('keyup keydown change', function () {
        this.value = this.value.replace(/[^A-Za-z ]/g, '')
    })
})

/**
 * Limita la cantidad de caracteres del textarea
 */
function validarTextarea (objetoTextarea, maxLength) {
    if (!maxLength) {
        maxLength = 1000
    }
    if (objetoTextarea.value.length > maxLength) {
        objetoTextarea.value = objetoTextarea.value.substr(0, maxLength)
    }
}
